import { absolutePath } from "../absolutePath";

interface InvoiceType {
  show: () => string;
}

export const invoice: InvoiceType = {
  show: () => absolutePath("account_payment_processors/invoices"),
};
